import {
  Box,
  Button,
  Link,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import ImageBackgroundOne from '@/assets/images/Vector.png';
import ImageBackgroundTwo from '@/assets/images/Vector1.png';
import ImageBackgroundOThree from '@/assets/images/Vector2.png';
import ImageBackgroundFour from '@/assets/images/Vector3.png';
import ImageBackgroundFive from '@/assets/images/Vector4.png';
import ImageBackgroundSix from '@/assets/images/Vector5.png';
import LogoEdu from '@/assets/images/LogoWhite.png';
import { useState } from 'react';

const style = {
  '& .MuiInputBase-input': {
    border: '1px solid rgba(128, 128, 128, 1)',
    height: '32px',
    padding: '0 0 0 5px',
    borderRadius: '4px',
    paddingLeft: '10p',
  },
  '& .MuiOutlinedInput-root': {
    color: 'rgba(30, 30, 30, 1)',

    '& fieldset': {
      borderColor: '#E0E3E7',
    },
    '&:hover fieldset': {
      borderColor: '#B2BAC2',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#6F7E8C',
    },
  },
};

const Register = () => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };
  return (
    <Box
      position={'relative'}
      sx={{ bgcolor: '#E04A4C', height: '100vh' }}
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
    >
      <img style={{ position: 'absolute', top: 0, left: 0 }} src={ImageBackgroundOne} alt="" />
      <img style={{ position: 'absolute', bottom: 0, left: 0 }} src={ImageBackgroundTwo} alt="" />
      <img style={{ position: 'absolute', bottom: 0, right: 0 }} src={ImageBackgroundOThree} alt="" />
      <img style={{ position: 'absolute', top: 0, right: 0 }} src={ImageBackgroundFour} alt="" />
      <img style={{ position: 'absolute', bottom: 0, right: 0 }} src={ImageBackgroundFive} alt="" />
      <img style={{ position: 'absolute', bottom: 0, right: 0 }} src={ImageBackgroundSix} alt="" />
      <Stack zIndex={1} alignItems={'center'}>
        <img src={LogoEdu} alt="" />

        <form>
          <Stack sx={{
            width: '352px',
            bgcolor: '#FFF',
            padding: '24px',
            borderRadius: '8px',
            color: '#000',
            boxShadow: '0px 0px 16px 4px #BE3F40'
          }}
            gap={'8px'}
          >
            <Typography sx={{ color: 'rgba(37, 37, 37, 1)', fontSize: '15px', fontWeight: 700, mb: '10px' }}>Escreva seu e-mail e solicite a nova senha</Typography>
            <Typography>E-mail*</Typography>
            <TextField sx={style} required id="email" />
            <Button
              sx={{ p: '7.5px 0', borderRadius: '24px', fontSize: '14px', background: 'rgba(21, 171, 81, 1)', mt: '20px', textTransform: 'none' }}
              variant="contained"
            >
              Enviar
            </Button>
            <Typography
              mt={'16.5px'}
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
              gap={1}
            >
              Lembrou a senha?
              <Link href="/login" underline="always" color={'#E04A4C'} fontWeight={'bold'}>
                Fazer login
              </Link>
            </Typography>
          </Stack>
        </form>
      </Stack>
    </Box>
  );
};

export default Register;
